import { render, staticRenderFns } from "./OpnetBottomBar.vue?vue&type=template&id=3af6179c&scoped=true&"
import script from "./OpnetBottomBar.vue?vue&type=script&lang=js&"
export * from "./OpnetBottomBar.vue?vue&type=script&lang=js&"
import style0 from "./OpnetBottomBar.vue?vue&type=style&index=0&id=3af6179c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af6179c",
  null
  
)

export default component.exports